var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUsIco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7312 23.5307C27.8822 23.6566 27.994 23.666 28.0853 23.666C28.1766 23.666 28.2883 23.6566 28.4394 23.5307C28.4394 23.5307 30.9827 21.6923 33.1987 19.4763C35.3911 17.2839 37.8731 14.4399 37.8731 10.2904C37.8733 4.88325 33.4925 0.500732 28.0854 0.500732C22.6783 0.500732 18.2974 4.88325 18.2974 10.2904C18.2974 14.4399 20.7794 17.2839 22.9718 19.4763C25.1878 21.6923 27.7312 23.5307 27.7312 23.5307ZM28.0854 5.3979C30.7861 5.3979 32.977 7.58872 32.977 10.2903C32.977 12.9918 30.7861 15.1819 28.0854 15.1819C25.3838 15.1819 23.1945 12.9918 23.1945 10.2903C23.1944 7.58872 25.3838 5.3979 28.0854 5.3979Z",
    fill: "url(#paint0_linear_2332_162)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4884 26.606C36.4884 26.606 35.8809 28.9337 33.1494 32.0027C35.5771 32.6764 37.398 31.5637 37.398 31.5637V34.9027H38.2755H38.8146H39.6928V31.5637C39.6928 31.5637 41.513 32.6765 43.9406 32.0027C41.2092 28.9337 40.6032 26.606 40.6032 26.606C41.2092 26.9097 42.3219 26.3368 42.3219 26.3368C39.8941 23.6384 38.5454 19.8618 38.5454 19.8618C38.5454 19.8618 37.1965 23.6384 34.7681 26.3368C34.7681 26.3368 35.8809 26.9097 36.4884 26.606Z",
    fill: "url(#paint1_linear_2332_162)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8588 34.9508C16.0396 33.3564 13.6285 32.9811 18.1889 30.034C21.5617 27.8541 28.9968 26.2448 32.8434 24.9834H24.9187C19.3873 26.0553 14.5114 26.99 10.7184 28.7088C11.4928 30.2379 12.6008 32.1187 13.9937 33.6658L16.0908 35.9968L13.3617 37.4022C13.5537 37.7336 13.7883 38.1019 14.044 38.4858C20.3727 40.0889 25.934 40.6782 21.1431 43.324C15.1435 46.6379 11.1167 48.9356 7.57861 50.5009H34.4551C37.1566 48.4501 41.8728 44.6099 42.6322 42.2608C43.7062 38.9383 40.1728 36.6128 27.8588 34.9508Z",
    fill: "url(#paint2_linear_2332_162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6998 42.2324C8.6998 42.2324 11.1204 43.7118 14.3484 42.8163C10.7167 38.7351 9.91006 35.6409 9.91006 35.6409C10.7167 36.0445 12.1961 35.2828 12.1961 35.2828C8.96816 31.6952 7.17461 26.6736 7.17461 26.6736C7.17461 26.6736 5.38115 31.6951 2.15234 35.2828C2.15234 35.2828 3.63174 36.0445 4.43916 35.6409C4.43916 35.6409 3.63174 38.7351 0 42.8163C3.22803 43.7118 5.64941 42.2324 5.64941 42.2324V46.6714H6.81572H7.53262H8.69971L8.6998 42.2324Z",
    fill: "url(#paint3_linear_2332_162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2332_162",
    x1: 28.0845,
    y1: 0.500732,
    x2: 28.0845,
    y2: 23.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2332_162",
    x1: 38.5446,
    y1: 19.8618,
    x2: 38.5446,
    y2: 34.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2332_162",
    x1: 25.1949,
    y1: 24.9834,
    x2: 25.1949,
    y2: 50.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2332_162",
    x1: 7.17368,
    y1: 26.6736,
    x2: 7.17368,
    y2: 46.6702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIco2);
export default __webpack_public_path__ + "static/media/why-us-ico-2.495819b0bd4c90ab26c59ce20fe3222f.svg";
export { ForwardRef as ReactComponent };